import React from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import NoItemFound from '../../assets/NoItem_Illustration.svg';

const STEPS = [
  'Open any product page',
  'Right-click → “Show Purchr”',
  'Click on the price and save!',
];

const StepRow = ({ index, title }) => (
  <Flex gap={{ base: '12px', lg: '16px' }} alignItems='center' width='100%'>
    <Flex
      flexShrink={0}
      width={{ base: '26px', lg: '30px' }}
      height={{ base: '26px', lg: '30px' }}
      borderRadius='50%'
      bg='purchr.orange.light'
      color='white'
      fontSize={{ base: '13px', lg: '15px' }}
      fontWeight='700'
      alignItems='center'
      justifyContent='center'
    >
      {index}
    </Flex>
    <Text
      fontSize={{ base: '15px', lg: '18px' }}
      fontWeight='700'
      color='purchr.header'
    >
      {title}
    </Text>
  </Flex>
);

const HowToGetStarted = () => {
  return (
    <Flex justifyContent='center' alignItems='center' height='100%' pt='40px'>
      <Flex
        flexDir='column'
        alignItems='center'
        gap={{ base: '20px', lg: '24px' }}
        padding={{ base: '16px 28px 32px', lg: '16px 40px 40px' }}
        maxWidth='420px'
      >
        <Image
          src={NoItemFound}
          width={{ base: '140px', lg: '180px' }}
          height='auto'
        />

        <Text
          fontSize={{ base: '22px', lg: '28px' }}
          fontWeight='700'
          color='purchr.header'
        >
          How to get started
        </Text>

        <Flex flexDir='column' gap={{ base: '14px', lg: '18px' }} width='100%'>
          {STEPS.map((step, i) => (
            <StepRow key={i} index={i + 1} title={step} />
          ))}
        </Flex>

        <Flex
          fontSize={{ base: '13px', lg: '15px' }}
          alignItems='center'
          gap='4px'
          pt='4px'
        >
          <Text color='purchr.gray.light'>Still having trouble ?</Text>
          <NavLink
            to='https://app.purchr.com/my-account#feedback'
            target='_blank'
          >
            <Text color='#0057FF' textDecoration='underline'>
              Tell us!
            </Text>
          </NavLink>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default HowToGetStarted;
